module.exports = __webpack_public_path__ + "static/media/completed.648aa7d9.svg";